import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';

import 'swiper/css';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initBlogCategoriesList(element) {
    const swiper = new Swiper(element.querySelector('.swiper-blog-categories-list'), {
        modules: [Navigation, FreeMode],
        slidesPerView: 'auto',
        spaceBetween: 12,
        allowTouchMove: true,
        freeMode: true,
        navigation: {
            nextEl: element.querySelector('.swiper-button-next'),
            prevEl: element.querySelector('.swiper-button-prev'),
        }
    });
}

function initAllBlogCategoriesList() {
    document.querySelectorAll('.blog-categories-list').forEach(function (element) {
        initBlogCategoriesList(element);
    });
}

function openDivLinkInNewTab() {
    document.querySelectorAll('div[data-file]').forEach(el => {
        el.addEventListener('click', (event) => {
            event.preventDefault();
            window.open(el.dataset.file, '_blank');
        });
        el.style.cursor = 'pointer';
    });
}

domContentLoadEvent(initAllBlogCategoriesList);
domContentLoadEvent(openDivLinkInNewTab);

